import intersect from '@alpinejs/intersect';
import ajax from '@imacrayon/alpine-ajax';
import masonry from 'alpinejs-masonry';

import { Alpine } from '@webentorCore/_alpine';

// Blocks Components
import { archiveList } from './blocks-components/archive-list';

// Extend Alpine with more components, plugins, etc.
document.addEventListener('alpine:init', () => {
  Alpine.plugin(ajax);
  Alpine.plugin(intersect);
  Alpine.plugin(masonry);

  // Blocks Components
  Alpine.data('archiveList', archiveList);
});
